import styled, { css } from 'styled-components';
import DefaultWestwingStudioLogo from '@westwing/ui-kit/Icons/Svgs/WestwingStudioLogo';
import { forTablet, forDesktop } from '@westwing/ui-kit/breakPoints';
import Heading from '@ids/components/Typography/Heading';
import GenericMedia from '@ids/components/Media';

export const HeroSection = styled.section`
    text-align: center;
    margin-bottom: 30px;

    ${forDesktop`
        height: 500px;
        display: flex;
        margin-bottom: 60px;
    `}
`;

export const TextWrapper = styled.div<{
    $color?: string;
    $backgroundColor?: string;
}>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px 25px;
    color: ${({ theme, $color }) => $color ?? theme.colors.charcoal100};
    background: ${({ theme, $backgroundColor }) => $backgroundColor ?? theme.colors.white};

    ${forTablet`
        order: 1;
        padding: 40px 75px;
        flex-basis: 29%;
    `}
`;

export const MediaWrapper = styled.div<{ $backgroundColor?: string }>`
    position: relative;
    line-height: 0;
    background: ${({ theme, $backgroundColor }) => $backgroundColor ?? theme.colors.white};

    ${forTablet`
        order: 2;
        flex-basis: 71%;
        height: 350px;
    `}

    ${forDesktop`
        height: 500px;
    
    `}
`;

type DisplayMobileOnly = { $mobileOnly: true; $fromTablet?: never };
type DisplayFromTablet = { $mobileOnly?: never; $fromTablet: true };
type DisplayType = DisplayMobileOnly | DisplayFromTablet;

const displayHeroMedia = css<DisplayType>`
    ${({ $fromTablet, $mobileOnly }) => {
        if ($fromTablet) {
            return css`
                display: none;

                ${forTablet`
                    display: inherit;
                `}
            `;
        }

        if ($mobileOnly) {
            return css`
                display: inherit;

                ${forTablet`
                    display: none;
                `}
            `;
        }

        return css``;
    }}
`;

export const Media = styled(GenericMedia)<DisplayType>`
    width: 100%;
    position: relative;
    color: ${({ theme }) => theme.colors.skeleton01};
    height: 100%;

    &[data-type='image'] {
        background: ${({ theme }) => theme.colors.skeleton01};
    }

    ${displayHeroMedia}
`;

export const WestwingStudioLogo = styled(DefaultWestwingStudioLogo)`
    margin: 0 auto 15px;

    svg {
        width: 200px;
    }

    ${forTablet`
        margin-bottom: 20px;

        svg {
            width: 300px;
        }
    `}

    ${forDesktop`
        margin-bottom: 40px;
    `}
`;

export const Title = styled(Heading)`
    width: min(470px, 100%);
    margin: 0 auto 15px;

    ${forTablet`
        margin-bottom: 20px;
    `}

    ${forDesktop`
        margin-bottom: 10px;
    `}
`;
